export type ILinkageEffect = 'onAnnoAdd' | 'onAnnoRemove' | 'onAnnoUpdate';

export interface ILinkage {
  name: string;
  level: 'element' | 'rawdata'; // 联动级别：帧之间 或 帧内文件间 的标注联动
  effects: Array<ILinkageEffect>; // 触发联动的时机
  slices: Array<string>; // 联动涉及的数据切片名称，引入联动时应检查是否有相应数据切片
  isEnabled: boolean; // 联动是否开启
}

export enum SeriesOptScope {
  /** 当前帧 */
  CURRENT = 'current',
  /** 所有帧 */
  ALL = 'all',
  /** 向前同步 */
  FORWARD = 'forward',
  /** 向后同步 */
  BACKWARD = 'backward',
}
